import Vue from 'vue';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import { gaEvent } from './ga-directives';

Vue.directive('gaEvent', gaEvent);
Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
// Vue.component('v-popover', VPopover);
